import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useEditNotes = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (data: {
      pubPropertyId: string;
      accountId: string;
      isPrivate: boolean;
      notes: string;
      id: string;
    }) => {
      const response = await axios.patch(`${t("notes")}/${data.id}`, data);
      return response.data;
    },
    onSuccess: (data, variables) => {
      if (onSuccess) {
        onSuccess(data);
      }
      queryClient.invalidateQueries({ queryKey: ["notes-list"] });
      // queryClient.setQueriesData(
      //   { queryKey: ["notes-list"] },
      //   (oldData: any) => {
      //     if (!oldData) return oldData;
      //     return oldData.map((note: any) =>
      //       note.id === variables.id ? data.data : note
      //     );
      //   }
      // );
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
